/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Environment } from '../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../axios-config';
import { comOffline } from '../../../offline/servico';
import { buscarProdutos, buscarProdutoPorEan } from '../../../offline/cadastros';

export interface IListagemDeProdutos {
  idproduto: string;
  idgrupo: string;
  idsubgrupo: string;
  descricao: string;
  un: string;
  ean: string;
  marca: string;
  infadd: string;
  origem: number;
  cfop: number;
  icms: number;
  cst: number;
  confins: number;
  pis: number;
  ipi:number;
  ncm: string;
  cest: string;
  anp: string;
  pnacional: number;
  pimportado: number;
  vpartida: number;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  comissao: number;
  margem: number;
  estoqueminino: number;
  status: boolean;
}

// Shape real devolvido por GET /produtos (ver ProdutosProvaider.getAll no
// backend) — usado pela busca paginada do autocomplete do PDV. Um subconjunto
// só com o que a listagem/carrinho precisam; os demais campos que a query
// devolve (foto, comissao, icms, pfrete, pseguro, infadd...) não são usados
// aqui e por isso ficam de fora.
export interface IProdutoBuscaPdv {
  idproduto: string;
  idref?: string;
  ean: string;
  descricao: string;
  marca: string;
  un: string;
  localizado?: string;
  codinterno?: number;
  referencia?: string;
  original?: boolean;
  preco: number;
  pvenda: number;
  quan?: number;
}
interface IListagemDeProdutosGetAlllist {
  idproduto: string;
  idgrupo: string;
  idsubgrupo: string;
  descricao: string;
  referencia: string;
  codbarraentrada: string;
  codbarrasaida: string;
  precocompra: number;
  precocusto: number;
  pvenda: number;
  precosaida: number;
  status: boolean;
  un: string;
  percentual: number;
  frete: number;
  local: string;
  diasvencimento: number;
  marca: string;
  vencimento: boolean;
  obs: string;
  codinterno?: number;
}
interface IProdutosByBarra {
  idproduto: string;
  idgrupo: string;
  idsubgrupo: string;
  descricao: string;
  codbarraentrada: string;
  codbarrasaida: string;
  precocompra: number;
  precocusto: number;
  pvenda: number;
  precosaida: number;
  status: boolean;
  un: string;
  percentual: number;
  frete: number;
  local: string;
  diasvencimento: number;
  marca: string;
  vencimento: boolean;
  obs: string;
  codinterno?: number;
}

type TComTotalCount = {
  data: IListagemDeProdutos[];
  totalCount: number;
}

type TComTotalCountBuscaPdv = {
  data: IProdutoBuscaPdv[];
  totalCount: number;
}

type TComTotalCountGetAlllist = {
  data: IListagemDeProdutosGetAlllist[];
  totalCount: number;
}
interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAllOnline = async (page = 1, filter = '', tipo = '', limit = 10, modobusca = 'contem'): Promise<TComTotalCountBuscaPdv | Error> => {
  try {
    const urlRelativa = `/produtos?page=${page}&limit=${limit}&filter=${encodeURIComponent(filter)}&tipo=${tipo}&modobusca=${modobusca}`;

    const { data, headers } = await Api.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 10),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getAlllist = async (filter = '', id = '', tipo = ''): Promise<TComTotalCountGetAlllist | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/produtos?limit=${Environment.LIMITE_DE_LINHAS}&tipo=${tipo}&filter=${filter}` : `/produtoslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getById = async (id: string): Promise<IListagemDeProdutosGetAlllist| Error> => {
  try {
    const { data } = await Api.get(`/produtos/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getByeanOnline = async (ean: string): Promise<IListagemDeProdutosGetAlllist| Error> => {
  try {
    const { data } = await Api.get(`/produtosbarra/${ean}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Online com fallback pro catálogo local (ver shared/offline) — a busca de
// produto do PDV continua funcionando sem internet, com a cópia baixada na
// última sincronização.
const getAll = (page = 1, filter = '', tipo = '', limit = 10, modobusca = 'contem'): Promise<TComTotalCountBuscaPdv | Error> =>
  comOffline(
    () => getAllOnline(page, filter, tipo, limit, modobusca),
    () => buscarProdutos(page, filter, tipo, limit, modobusca),
  );

const getByean = (ean: string): Promise<IListagemDeProdutosGetAlllist | Error> =>
  comOffline(
    () => getByeanOnline(ean),
    async () => (await buscarProdutoPorEan(ean)) ?? new Error('Produto não encontrado.'),
  );

export const ProdutosService = {
  getAll,
  getAlllist,
  getById,
  getByean,
};